var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.434663 4.90267C0.434663 2.37092 2.49277 0.312817 5.02452 0.312817C7.55626 0.312817 9.61437 2.37092 9.61437 4.90267C9.61437 5.88943 9.29297 6.80289 8.7573 7.54155L11.3342 10.1241C11.4864 10.2819 11.5653 10.4906 11.5653 10.7161C11.5653 11.1841 11.2214 11.545 10.7421 11.545C10.5222 11.545 10.3023 11.4717 10.1444 11.3082L7.55063 8.71439C6.82888 9.20495 5.96617 9.49252 5.02452 9.49252C2.49277 9.49252 0.434663 7.43442 0.434663 4.90267ZM1.63005 4.90267C1.63005 6.7747 3.14685 8.29713 5.02452 8.29713C6.89654 8.29713 8.41898 6.7747 8.41898 4.90267C8.41898 3.03064 6.89654 1.50821 5.02452 1.50821C3.14685 1.50821 1.63005 3.03064 1.63005 4.90267Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.3dcdb90d5fb69e1c88e5f5e2d8ab31ba.svg";
export { ForwardRef as ReactComponent };